<template>
  <div><form-language v-model="data" @selected="nextHandler" /></div>
</template>

<script>
import FormLanguage from "../components/FormLanguage"
import ModParticipant from "../modules/ModParticipant"

export default {
  name: "ViewLanguage",
  components: {
    FormLanguage,
  },
  data() {
    return {
      data: ModParticipant.data,
    }
  },
  methods: {
    nextHandler() {
      this.$specs.withWelcome
        ? this.$router.push("/welcome")
        : this.$specs.withInstructions
        ? this.$router.push("/instructions")
        : this.$specs.tanProtected
        ? this.$router.push("/tan")
        : this.$specs.registrationNeeded
        ? this.$router.push("/register")
        : this.$router.push("/vip")
    },
  },
}
</script>